import { render, staticRenderFns } from "./stocklevels.vue?vue&type=template&id=0aa77f54&"
import script from "./stocklevels.vue?vue&type=script&lang=js&"
export * from "./stocklevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports